import React from "react";
import { Layout } from "antd";
import { ReactComponent as EuropeanUnionLogo } from "assets/icons/european_union.svg";
import { ReactComponent as GreeceGovernmentLogo } from "assets/icons/government-greece-logo2.svg";
import { ReactComponent as GreenMinistryLogo } from 'assets/icons/green_ministry_gov.svg';
import TaipedLogo from 'assets/icons/taipedLogo.jpeg';

const { Content } = Layout;

const Footer = () => {
  return (
    <div>
      <Content className='footer'>
        <GreenMinistryLogo />
        <div className="taiped-logo-wrapper">
          <img src={TaipedLogo} alt="Taiped Logo" className='taiped_logo'/>
        </div>
        <EuropeanUnionLogo />
        <GreeceGovernmentLogo />           
      </Content>
    </div>
  )
}

export default Footer